import React from 'react';
import { Hero } from './components/Hero';
import { Metrics } from './components/Metrics';
import { SocialProofInitial } from './components/SocialProofInitial';
import { PainPoints } from './components/PainPoints';
import { ProductHero } from './components/ProductHero';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { UpsellDetail } from './components/UpsellDetail';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-DEFAULT text-white font-sans selection:bg-brand-DEFAULT selection:text-dark-DEFAULT" data-id="element-0">
      <Hero data-id="element-1" />
      <Metrics data-id="element-2" />
      <SocialProofInitial data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductHero data-id="element-5" />
      <Tomos data-id="element-6" />
      <Bonos data-id="element-7" />
      <Urgency data-id="element-8" />
      <Pricing data-id="element-9" />
      <UpsellDetail data-id="element-10" />
      <Testimonials data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <ComparisonTable data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}